import gql from 'graphql-tag';

export default gql`
    mutation DisableJob($input: DisableJobInput) {
        disableJob(input: $input) {
            errors
        }
    }
`;
